<div class="text-center border-top p-4 d-none d-sm-block">
    <button class="btn btn-grn rounded-pill btn-lg-custom my-2 mx-3" (click)="handleprevpage()" [hidden]="hidebackbtn"
        data-testid="shared.buttonbar.go-back-btn">
        <i class="fa fa-long-arrow-left me-3 align-middle font-24" aria-hidden="true"></i>Go Back
    </button>
    <button class="btn btn-primary rounded-pill btn-lg-custom my-2 mx-4" (click)="handlestoppage()" [hidden]="!showstopbtn"
        data-testid="shared.buttonbar.stop-btn">
        Stop
    </button>
    <button class="btn btn-primary rounded-pill btn-lg-custom my-2 mx-4" (click)="handleupload()" [hidden]="!showuploadbtn"
        data-testid="shared.buttonbar.upload-btn">
        Upload Statements
    </button>
    <button class="btn btn-primary rounded-pill btn-lg-custom my-2 mx-4" (click)="handlenextpage()" [hidden]="hidenextbtn"
        data-testid="shared.buttonbar.continue-btn">
        Continue<i class="fa fa-long-arrow-right ms-3 align-middle font-24" aria-hidden="true"></i>
    </button>
    <button class="btn btn-primary rounded-pill btn-lg-custom my-2 mx-4" (click)="handlenextpage()" [hidden]="!showdonebtn"
        data-testid="shared.buttonbar.all-done-btn">
        All done for now
    </button>
    <button class="btn keep-going-btn rounded-pill btn-lg-custom my-2 mx-4" (click)="handledone()" [hidden]="!showdonebtn"
        data-testid="shared.buttonbar.keep-going-btn">
        Keep going<i class="fa fa-long-arrow-right ms-3 align-middle font-24" aria-hidden="true"></i>
    </button>
</div>
<div class="border-top d-block d-sm-none col-sm-12 text-center px-0">
    <button class="btn btn-grn rounded-pill btn-sm mt-4 mb-4 float-start" (click)="handleprevpage()" [hidden]="hidebackbtn"
        data-testid="shared.buttonbar.mobile-back-btn">
        Back
    </button>
    <button class="btn btn-grn rounded-pill btn-sm mt-4 mb-4 text-center" [ngClass]="{'float-start':hidebackbtn}" (click)="handledone()" [hidden]="!showdonebtn"
        data-testid="shared.buttonbar.mobile-done-btn">
        Done
    </button>
    <button class="btn btn-primary rounded-pill btn-sm mt-4 mb-4 float-end" (click)="handlenextpage()" [hidden]="hidenextbtn"
        data-testid="shared.buttonbar.mobile-next-btn">
        Next
    </button>
</div>
